<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Mission Unstoppable
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand the significance of Jesus' ascension into heaven and the ongoing work of the Holy Spirit in growing the Church on earth.
                        </li>
                        <li>
                            To understand that the good news about Jesus will often invite opposition and persecution from those who do not believe.
                        </li>
                        <li>
                            To see how, through the preaching of the good news about Jesus, people from all nations and all backgrounds can be forgiven and become part of the Church.
                        </li>
                        <li>
                            To encourage Christians to be bold and prayerful in telling others about Jesus and their need to trust in him.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series begins with Jesus' ascension into heaven and his promise that the Holy Spirit would come upon
                        the apostles to empower them to tell people all over the world about Jesus. This mission would begin in Jerusalem,
                        move to the surrounding area (Judea), neighbouring countries (Samaria) and even to distant lands (Ethiopia and beyond).
                    </p>
                    <p>
                        The series explores how this happened despite opposition, persecution and even the murder of
                        those spreading the good news about Jesus. It becomes clear that this is a super-natural movement,
                        empowered by the Holy Spirit and under the control of King Jesus.The gospel advances and the Church
                        grows to include people from any country (including an Ethiopian man), from any religion
                        (including a Jewish Pharisee and a Gentile centurion), from any background
                        (including a moral man and a murderous persecutor of Christians).
                        Everyone needs to hear about Jesus and turn to trust in him ? but not everyone will.
                        The series ends by highlighting the often mixed response to the good news about Jesus
                        as it's illustrated in one of Paul's early missionary journeys.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - The Ascension (Acts 1:1-11)
                    </p>
                    <p>
                        Lesson 2 - The Holy Spirit Arrives (Acts 2:1-41)
                    </p>
                    <p>
                        Lesson 3 - Opposition (Acts 5:12-42)
                    </p>
                    <p>
                        Lesson 4 - Persecution (Acts 6:7 - 8:3)
                    </p>
                    <p>
                        Lesson 5 - Philip and the Ethiopian (Acts 8:1-8, 26-40)
                    </p>
                    <p>
                        Lesson 6 - Saul's Conversion (Acts 9:1-22)
                    </p>
                    <p>
                        Lesson 7 - Cornelius' Conversion (Acts 10:1-48)
                    </p>
                    <p>
                        Lesson 8 - To the Ends of the Earth (Acts 14:8-22)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "MissionUnstoppable",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Mission Unstoppable`,
        };
    },
};
</script>
